/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { createComment, fetchComments } from '../../actions';
import Comment from './comment';

function Comments(props) {
  const { pageID } = props.match.params; // get current page
  const [newComment, setNewComment] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  // NOTE to my teammates :P --
  // const [var, setVar] = useState(X) format initializes a variable to X
  // and creates function (setVar) to be used for updating it whenever,
  // as if it was state var.

  // load page on first-load
  useEffect(() => {
    props.fetchComments(pageID);
  }, []);

  // create new comment, then update comments
  const sendCreateComment = () => {
    if (!newComment) {
      setErrorMsg('Add a message!');
      return;
    }
    createComment(newComment, pageID).then(() => {
      props.fetchComments(pageID);
      setNewComment('');
    }).catch((err) => {
      console.log(err);
    });
  };

  // on enter in input, run send-comment.
  const keyUp = (e) => {
    if (e.key === 'Enter') {
      sendCreateComment();
    }
  };

  return (
    <div className="comments-section">
      <h2>Comments:</h2>
      {props.comments.map((comment) => (
        <Comment comment={comment} key={comment.id} />
      ))}
      {props.comments.length === 0 ? <p className="first-comment">Be the first to comment.</p> : <></>}
      <div className="comment-maker">
        <input id="new-comment" onKeyUp={keyUp} onChange={(e) => setNewComment(e.target.value)} value={newComment} placeholder="Add comment..." />
        <button onClick={() => sendCreateComment()} className="icon-button fake-button" aria-label="send comment" type="button">
          <i className="fas fa-paper-plane" />
        </button>
      </div>
      <p className="error-msg">{errorMsg}</p>
    </div>
  );
}

const mapStateToProps = (state) => (
  {
    comments: state.comments,
  }
);
export default withRouter(connect(mapStateToProps, { fetchComments })(Comments));
